import Emitter from "tiny-emitter";
export const EventBus = new Emitter();
EventBus.$emit = EventBus.emit;
EventBus.$on = EventBus.on;
EventBus.$off = EventBus.off;
